import { render, staticRenderFns } from "./ProposalItem.vue?vue&type=template&id=6a959b14&scoped=true&"
import script from "./ProposalItem.vue?vue&type=script&lang=js&"
export * from "./ProposalItem.vue?vue&type=script&lang=js&"
import style0 from "./ProposalItem.vue?vue&type=style&index=0&id=6a959b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a959b14",
  null
  
)

export default component.exports